import { LeftRightBasedExpression } from '../LeftRightBasedExpression.js';
export class SubstractionExpression extends LeftRightBasedExpression {
    evaluate(visitor) {
        const { left, right } = this._evaluateLeftRightExpression(visitor);
        return left - right;
    }
}
//# sourceMappingURL=SubstractionExpression.js.map